import styled from 'styled-components'
import { Typography, Colors } from 'cio-design-library/design-tokens'
import InfoBox from 'builder/components/InfoBox'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Header = styled.h3`
  ${Typography.sizes.Caps};
  font-weight: ${Typography.weights.demibold};
  color: ${Colors.Neutral50};

  ${Media.Phone`
    text-align: center;
  `}
`

export const InfoBoxComponent = styled(InfoBox)`
  gap: 8px;
  margin: 4px 0;
  padding: 12px;
`
